// {{------- New Working code------------}}
import React, { useEffect } from "react";
import AppRoutes from "./routes/AppRoutes";
import axios from "axios";
import { HelmetProvider } from "react-helmet-async"; // ✅ ADD THIS
import WhatsAppButton from "./components/WhatsAppButton";

const API_BASE = process.env.REACT_APP_API_URL;

const apiClient = axios.create({
  timeout: 10000,
  headers: { "Content-Type": "application/json" },
});

function App() {
  useEffect(() => {
    const today = new Date().toDateString();
    const lastVisit = localStorage.getItem("visitDate");

    if (lastVisit !== today) {
      axios
        .post(`${API_BASE}/visitor`)
        .then((res) => {
          console.log(res.data);
          localStorage.setItem("visitDate", today);
        })
        .catch((err) => {
          console.error("Visitor API error:", err);
        });
    }
  }, []);

  // ✅ Expiry Check
  useEffect(() => {
    const loginTime = sessionStorage.getItem("loginTime");

    if (loginTime) {
      const now = Date.now();
      if (now - parseInt(loginTime) > 3600000) {
        sessionStorage.clear();
        localStorage.clear();
        window.location.href = "/auth";
      }
    }
  }, []);

  // ✅ Load location data
  useEffect(() => {
    const loadLocationData = async () => {
      try {
        if (!sessionStorage.getItem("country_code")) {
          const res = await apiClient.get(`${API_BASE}/country_code`);
          sessionStorage.setItem(
            "country_code",
            JSON.stringify(res.data.result || []),
          );
          localStorage.setItem(
            "country_code",
            JSON.stringify(res.data.result || []),
          );
        }

        if (!sessionStorage.getItem("states")) {
          const res = await apiClient.get(`${API_BASE}/states`);
          sessionStorage.setItem(
            "states",
            JSON.stringify(res.data.result || []),
          );
          localStorage.setItem("states", JSON.stringify(res.data.result || []));
        }

        if (!sessionStorage.getItem("districts")) {
          const res = await apiClient.get(`${API_BASE}/districts`);
          sessionStorage.setItem(
            "districts",
            JSON.stringify(res.data.result || []),
          );
          localStorage.setItem(
            "districts",
            JSON.stringify(res.data.result || []),
          );
        }

        if (!sessionStorage.getItem("cities")) {
          const res = await apiClient.get(`${API_BASE}/cities`);
          sessionStorage.setItem(
            "cities",
            JSON.stringify(res.data.result || []),
          );
          localStorage.setItem("cities", JSON.stringify(res.data.result || []));
        }
      } catch (error) {
        console.error("Location API Error:", error);
      }
    };

    loadLocationData();
  }, []);

  return (
    <HelmetProvider>
      {" "}
      {/* ✅ FIX */}
      <AppRoutes />
      <WhatsAppButton />
    </HelmetProvider>
  );
}

export default App;
